import { RouteLocationRaw } from "vue-router";

export type ButtonColor = [
  "primary",
  "primary-dark",
  "primary-light",
  "info",
  "success",
  "success-light",
  "danger",
  "white",
  "black",
  "gray",
][number];

export interface ButtonProps {
  color?: ButtonColor;
  isSmall?: boolean;
  isRounded?: boolean;
  isLoading?: boolean;
  leadingIcon?: string;
  trailingIcon?: string;
  to?: Partial<RouteLocationRaw>;
  disabled?: boolean;
  isCondensed?: boolean;
}

export function colorClasses(color: ButtonColor, hasBorder = true) {
  switch (color) {
    case "white":
      return "bg-white text-gray-900 ring-1 ring-gray-300 hover:brightness-95";
    case "info":
      return "bg-secondary text-primary hover:brightness-95";
    case "primary-dark":
      return "bg-primary text-white hover:brightness-95";
    case "success":
      return "bg-green-500 text-white hover:brightness-95";
    case "success-light":
      return "bg-green-200 text-green-900 hover:brightness-95";
    case "danger":
      return hasBorder
        ? "bg-red-500 text-white hover:brightness-95"
        : "ring-1 ring-transparent hover:ring-red-500 text-red-500 rounded-md active:shadow-inner active:ring-red-600 active:text-red-600";
    case "gray":
      return "bg-gray-300 hover:brightness-95 active:bg-gray-400";
    default:
      return "bg-primary text-primary-foreground hover:brightness-95";
  }
}
